export default __webpack_public_path__ + "static/media/therawee-logo-light-compressed.c7a30c2c.png";